module.exports = __webpack_public_path__ + "media/a3.03fadab1.mp4";